import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { ApiRequestError } from "@/api/errors"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatSeconds(total: number) {
  const minutes = Math.floor(total / 60)
  const seconds = total % 60
  return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
}

export function saveFileToDisk(file: File, filename: string) {
  const a = document.createElement("a")
  const url = window.URL.createObjectURL(file)
  a.href = url
  a.download = filename
  a.click()
  window.URL.revokeObjectURL(url)
  a.remove()
}

// Guarantees a renderable string — never an object/array that would crash React.
const toMessage = (value: unknown): string =>
  typeof value === "string" && value.length > 0
    ? value
    : "Ha ocurrido un error. Inténtalo nuevamente."

export const parseError = (err: Error) => {
  if (err instanceof ApiRequestError) {
    return toMessage(err.message)
  }

  if (err instanceof Error && "issues" in err) {
    console.error(err)
    return "Error de validación"
  }

  return toMessage(err.message)
}
